import React from "react";
import { InputGroup, Button, Switch, Icon } from "@blueprintjs/core";
import { validate } from "validate.js";
import validators from "./validators";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../components/LoadingIndicator";
import ReactPasswordStrength from "react-password-strength";
import GoogleLocation from "../../components/GoogleLocation";
import GetUserLocation from "../../components/GetUserLocation";
import SendInvitesToFriends from "./SendInvitesToFriends";
import CustomIcon from "../../components/CustomIcon";
import ReactGA from "react-ga";

class CreateGroupForm extends React.Component {
  id = 0;
  state = {
    register_form: {
      user_name: "",
      first_name: "",
      last_name: "",
      password: "",
      accepted_terms: false,
      address: "",
      max_owners_no: this.props.product.suggested_members_no,
      friends: {}
    },
    validation_errors: {},
    show_location_loader: false,
    show_location_modal: false,
    location: {
      lat: "",
      lon: ""
    }
  };

  newMemberForm = () => {
    this.setState(state => {
      const id = this.id++;
      state.register_form.friends[id] = { id, email: "" };
      return { register_form: { ...state.register_form, friends: state.register_form.friends } };
    });
  };

  removeFriend = id => {
    this.setState(state => {
      delete state.register_form.friends[id];
      return { register_form: { ...state.register_form, friends: state.register_form.friends } };
    });
  };

  removeFriends = () => {
    this.setState(state => {
      return { register_form: { ...state.register_form, friends: {} } };
    });
  };

  changeChanelType = (type, id) => {
    this.setState(state => {
      state.register_form.friends[id] = { id, [type]: "" };
      return { register_form: { ...state.register_form, friends: state.register_form.friends } };
    });
  };

  updateFields = (event, id) => {
    if ("password" in event) {
      this.setState({
        register_form: {
          ...this.state.register_form,
          password: event.password
        }
      });
    } else {
      if (id >= 0) {
        this.setState({
          register_form: {
            ...this.state.register_form,
            friends: { ...this.state.register_form.friends, [id]: { id, [event.target.id]: event.target.value } }
          }
        });
      } else {
        this.setState({
          register_form: {
            ...this.state.register_form,
            [event.target.id]: event.target.value
          }
        });
      }
    }
  };

  termsAndConditionsChanged = event => {
    this.setState({
      register_form: {
        ...this.state.register_form,
        accepted_terms: event.target.checked
      }
    });
  };

  submitForm = e => {
    e.preventDefault();
    ReactGA.event({
      category: "B2B widget",
      action: "Clicked create circle"
    });
    const validationErrors = validate(this.state.register_form, validators);
    this.setState({
      validation_errors: validationErrors ? validationErrors : {}
    });
    if (!validationErrors) {
      this.props.onRegister({
        user_name: this.state.register_form.user_name.toLowerCase(), //email
        password: this.state.register_form.password,
        first_name: this.state.register_form.first_name,
        last_name: this.state.register_form.last_name,
        lat: this.state.register_form.lat,
        lon: this.state.register_form.lon,
        address: this.state.register_form.address,
        city: this.state.register_form.city,
        country: this.state.register_form.country,
        max_owners_no: this.props.product.suggested_members_no,
        friends: Object.keys(this.state.register_form.friends).length ? this.state.register_form.friends : null
      });
    }
  };

  selectedLocation = location => {
    this.setState({
      show_location_modal: false,
      register_form: {
        ...this.state.register_form,
        address: location.address,
        city: location.city,
        country: location.country,
        lat: String(location.lat),
        lon: String(location.lng)
      }
    });
  };

  showLocationModal = () => {
    if (this.state.register_form.lat && this.state.register_form.lon) {
      this.setState({
        show_location_modal: true,
        location: { lat: this.state.register_form.lat, lon: this.state.register_form.lon }
      });
    } else {
      this.setState({ show_location_loader: true });
      GetUserLocation(
        position => {
          this.setState({
            show_location_modal: true,
            show_location_loader: false,
            location: { lat: position.coords.latitude, lon: position.coords.longitude }
          });
        },
        error => {
          this.setState({ show_location_modal: true, show_location_loader: false });
        }
      );
    }
  };

  render() {
    return (
      <>
        <GoogleLocation
          location={{ lat: this.state.location.lat, lng: this.state.location.lon }}
          showModal={this.state.show_location_modal}
          onClose={() => {
            this.setState({ show_location_modal: false });
          }}
          onSave={this.selectedLocation}
        />
        <form onSubmit={this.submitForm}>
          <div className={this.state.validation_errors.user_name ? "form-group error" : "form-group"}>
            {this.state.validation_errors.user_name && (
              <label htmlFor="user_name">
                <Translate value={this.state.validation_errors.user_name[0]} />
              </label>
            )}
            <InputGroup
              leftIcon="envelope"
              type="email"
              placeholder={I18n.t("sign_up.placeholders.email_address")}
              fill={true}
              id="user_name"
              disabled={this.props.isLoading}
              intent={this.state.validation_errors.user_name ? "danger" : ""}
              onChange={this.updateFields}
            />
          </div>
          <div className={this.state.validation_errors.first_name ? "form-group error" : "form-group"}>
            {this.state.validation_errors.first_name && (
              <label htmlFor="first_name">
                <Translate value={this.state.validation_errors.first_name[0]} />
              </label>
            )}
            <InputGroup
              leftIcon="person"
              type="text"
              placeholder={I18n.t("user_details.placeholders.first_name")}
              fill={true}
              id="first_name"
              disabled={this.props.isLoading}
              intent={this.state.validation_errors.first_name ? "danger" : ""}
              onChange={this.updateFields}
            />
          </div>
          <div className={this.state.validation_errors.last_name ? "form-group error" : "form-group"}>
            {this.state.validation_errors.last_name && (
              <label htmlFor="last_name">
                <Translate value={this.state.validation_errors.last_name[0]} />
              </label>
            )}
            <InputGroup
              leftIcon="person"
              type="text"
              placeholder={I18n.t("user_details.placeholders.last_name")}
              fill={true}
              id="last_name"
              disabled={this.props.isLoading}
              intent={this.state.validation_errors.last_name ? "danger" : ""}
              onChange={this.updateFields}
            />
          </div>
          <div className={this.state.validation_errors.password ? "form-group error" : "form-group"}>
            {this.state.validation_errors.password && (
              <label htmlFor="password">
                <Translate value={this.state.validation_errors.password[0]} />
              </label>
            )}
            <div className="react-pass-strength">
              <ReactPasswordStrength
                minLength={5}
                minScore={2}
                scoreWords={[
                  I18n.t("password_score.weak"),
                  I18n.t("password_score.okay"),
                  I18n.t("password_score.good"),
                  I18n.t("password_score.strong"),
                  I18n.t("password_score.stronger")
                ]}
                tooShortWord={I18n.t("password_score.too_short")}
                changeCallback={this.updateFields}
                inputProps={{
                  name: "password",
                  autoComplete: "off",
                  className: "bp3-input",
                  placeholder: I18n.t("sign_up.placeholders.password")
                }}
              />
              <Icon icon="lock" iconSize={16} className="pass-strength-icon" />
            </div>
          </div>
          <div
            className={this.state.validation_errors.address ? "form-group error" : "form-group"}
            onClick={this.showLocationModal}>
            <label htmlFor="address">
              {this.state.validation_errors.address ? (
                <Translate value={this.state.validation_errors.address[0]} />
              ) : (
                <Translate value={"user_details.labels.location"} />
              )}
            </label>
            <InputGroup
              readOnly={true}
              leftIcon="globe"
              type="text"
              disabled={false}
              placeholder={I18n.t("user_details.placeholders.location")}
              fill={true}
              id="address"
              value={this.state.register_form.address}
              className="has-button circle-form-address"
              rightElement={
                this.state.show_location_loader ? (
                  <LoadingIndicator />
                ) : (
                  <Button className="input-button right">
                    <Icon icon="locate" iconSize="20" className="icon" />
                  </Button>
                )
              }
            />
          </div>
          <div className={this.state.validation_errors.accepted_terms ? "form-group error" : "form-group"}>
            {this.state.validation_errors.accepted_terms && (
              <label htmlFor="password">
                <Translate value={this.state.validation_errors.accepted_terms[0]} />
              </label>
            )}
            <Switch
              checked={this.state.register_form.accepted_terms}
              label={
                <span>
                  <Translate value="sign_up.read_and_accept" />{" "}
                  <a target="_blank" href="/privacy-policy">
                    <Translate value="menu.privacy_policy" />
                  </a>{" "}
                  &amp;{" "}
                  <a target="_blank" href="/terms-of-use">
                    <Translate value="menu.terms_of_use" />
                  </a>
                </span>
              }
              onChange={this.termsAndConditionsChanged}
            />
          </div>
          {this.props.private_group && (
            <SendInvitesToFriends
              updateFields={this.updateFields}
              errors={this.state.validation_errors.friends}
              friends={this.state.register_form.friends}
              newMemberForm={this.newMemberForm}
              removeFriend={this.removeFriend}
              removeFriends={this.removeFriends}
              changeChanelType={this.changeChanelType}
            />
          )}
          <div
            className="b2b-share-group"
            onClick={_ => {
              this.props.submitRef.current.buttonRef.click();
            }}>
            <div className="label">
              <Translate value="b2b.share_group" />
            </div>
            <div className="share-buttons-wrapper">
              <div className="button">
                <CustomIcon name="b2b-facebook" className="icon" size="24" />
              </div>
              <div className="button">
                <CustomIcon name="b2b-whatsapp" className="icon" size="24" />
              </div>
              <div className="button">
                <CustomIcon name="b2b-email" className="icon" size="24" />
              </div>

              <div className="button">
                <CustomIcon name="b2b-twitter" className="icon" size="24" />
              </div>
              <div className="button">
                <CustomIcon name="b2b-url" className="icon" size="24" />
              </div>
            </div>
          </div>
          <Button
            intent="primary"
            fill={true}
            type="submit"
            style={{ display: "none" }}
            ref={this.props.submitRef}></Button>
        </form>
      </>
    );
  }
}

export default CreateGroupForm;
